import { dateKeyFromDate } from "../../bonLivraison/model/bonLivraisonRules";

// Dates, heures, initiales et couleurs d'avatar affichées dans le suivi.

const pad2 = value => String(value).padStart(2, "0");

function parseDate(str) {
    const d = new Date(str);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function todayInput() {
    return dateKeyFromDate(new Date());
}

export function formatDate(str) {
    if (!str) return "";
    const d = parseDate(str);
    if (!d) return str;
    return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${String(d.getFullYear()).slice(2)} · ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function formatTime(str) {
    if (!str) return "";
    const d = parseDate(str);
    if (!d) return "";
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function deliveryDateKey(str) {
    if (!str) return "date-inconnue";
    const d = parseDate(str);
    if (!d) return str;
    return dateKeyFromDate(d);
}

export function formatDeliveryDateHeader(str) {
    if (!str) return "Date non renseignée";
    const d = parseDate(str);
    if (!d) return str;
    return new Intl.DateTimeFormat("fr-FR", {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
    }).format(d);
}

export function formatDateTime(str) {
    if (!str) return null;
    const d = parseDate(str);
    if (!d) return str;
    return `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function initials(nom, prenom) {
    return (((prenom || "")[0] || "") + ((nom || "")[0] || "")).toUpperCase() || "?";
}

export const AVATAR_PALETTE = [
    { bg: "#dbeafe", color: "#1d4ed8" },
    { bg: "#dcfce7", color: "#15803d" },
    { bg: "#fef3c7", color: "#b45309" },
    { bg: "#ede9fe", color: "#7c3aed" },
    { bg: "#fce7f3", color: "#be185d" },
    { bg: "#e0f2fe", color: "#0369a1" },
];

export function hashColor(str) {
    let h = 0;
    for (let i = 0; i < (str || "").length; i++) h = (h * 31 + str.codePointAt(i)) & 0xffff;
    return AVATAR_PALETTE[h % AVATAR_PALETTE.length];
}
